import React, { useCallback, useState } from 'react';
import DescriptionConditionBuilderView from '../view/DescriptionConditionBuilderView';

const DescriptionConditionBuilderEngine = props => {
  const { dispatch } = props;

  const [removeHovered, setRemovedHovered] = useState(false);
  const [deleteMe, setDeleteMe] = useState(false);

  const updateCondition = (
    conditionsStateIndex,
    comparisonIndex
  ) => payload => {
    dispatch({
      type: 'updateCondition',
      textNodeIndex: conditionsStateIndex,
      conditionNodeIndex: comparisonIndex,
      payload
    });
  };

  const remove = (conditionsStateIndex, comparisonIndex) => {
    dispatch({
      type: 'removeCondition',
      textNodeIndex: conditionsStateIndex,
      conditionNodeIndex: comparisonIndex
    });
  };

  const addCondition4Description = conditionsStateIndex => {
    dispatch({
      type: 'addCondition',
      textNodeIndex: conditionsStateIndex
    });
  };

  const removeDescription = () => {
    dispatch({
      type: 'removeText',
      payload: { id: props.id }
    });
  };

  const updateRootAndOr = (value, conditionsStateIndex) => {
    dispatch({
      type: 'updateText',
      textNodeIndex: conditionsStateIndex,
      payload: { andOr: value }
    });
  };

  const emojiCallback = useCallback(
    value => {
      props.onDescriptionChange({target: {value: value}}, props.conditionsStateIndex, false);
    },
    [props.conditionsStateIndex, props.onDescriptionChange]
  );

  const viewProps = {
    ...props,
    updateCondition,
    remove,
    addCondition4Description,
    removeDescription,
    updateRootAndOr,
    removeHovered,
    setRemovedHovered,
    deleteMe,
    setDeleteMe,
    emojiCallback // needs to be after ...props because there's a different one to override
  };

  return <DescriptionConditionBuilderView {...viewProps} />;
};

export default DescriptionConditionBuilderEngine;
